<template>
    <div>
        <Preloader />
        <Header />
        <main class="flex-1 relative">
            <div class="page-transition-overlay"></div>
                <router-view />
        </main>
        <Footer />
        <CookieBanner />
    </div>
</template>

<script setup>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Preloader from './components/Preloader.vue';
import CookieBanner from './components/CookieBanner.vue';
import { onMounted } from 'vue'
import { initFlowbite } from 'flowbite'

onMounted(() => {
    initFlowbite();
    const selectedCompany = JSON.parse(localStorage.getItem('selectedCompany'));
    document.documentElement.style.setProperty('--color-primary', selectedCompany?.color || '#D33377');
})

</script>
